module.exports = __webpack_public_path__ + "img/user-journal.c62181ff.png";